import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe } from '@ngx-translate/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { User, SecondaryUserFilter } from '@nimmsta/ng-commons-lib/models';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { UserService } from '@nimmsta/ng-commons-lib/services/user';
import { Select } from 'primeng/select';

_('user.secondary-user.add');
_('user.secondary-user.select');

@Component({
  selector: 'app-add-secondary-user-to-org-modal',
  templateUrl: './add-secondary-user-to-org-modal.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    ErrorComponent,
    Select,
  ],
})
export class AddSecondaryUserToOrgModalComponent implements OnInit {
  private dialogRef = inject(DynamicDialogRef);
  private dialogConfig = inject(
    DynamicDialogConfig<{ secondaryOrganizationId: string }>,
  );
  private userService = inject(UserService);

  // Properties that can be set when opening the modal
  secondaryOrganizationId = this.dialogConfig.data!.secondaryOrganizationId;

  selectedUserControl = new FormControl<string>('');
  availableUsers: (User & { displayName: string })[] = [];
  error?: HttpErrorResponse;
  isLoading = false;

  ngOnInit(): void {
    this.loadMainUsers();
  }

  private loadMainUsers(): void {
    // Load users from current user's organization that are not secondary users
    this.userService.secondaryUserFilter =
      SecondaryUserFilter.WITHOUT_SECONDARY_USERS;

    this.userService.list({ pageSize: 9999 }).subscribe({
      next: (users) => {
        // Filter out users who are already secondary users of the target organization
        this.availableUsers = users.content
          .filter(
            (user) =>
              !user.secondaryOrganizations?.some(
                (org) => org.id === this.secondaryOrganizationId,
              ),
          )
          .map((user) => ({
            ...user,
            displayName: `${user.given_name} ${user.family_name} (${user.email})`,
          }));
      },
      error: (error) => {
        this.error = error;
      },
    });
  }

  addSecondaryUser(): void {
    const selectedUserId = this.selectedUserControl.value;
    if (!selectedUserId) {
      return;
    }

    this.isLoading = true;
    this.error = undefined;

    // Use the new UserService method to add user to secondary organization
    this.userService
      .addUserToSecondaryOrganization(
        selectedUserId,
        this.secondaryOrganizationId,
      )
      .subscribe({
        next: () => {
          this.close(true);
        },
        error: (error: HttpErrorResponse) => {
          this.error = error;
          this.isLoading = false;
        },
      });
  }

  close(success = false): void {
    this.dialogRef.close(success);
  }
}
